import React from "react";
import { createUseStyles } from "react-jss";

interface IPropertyDetail {
  icon: string;
  title?: string;
  description?: string;
  height?: number;
  width?: number;
}

export default function PropertyDetail(props: IPropertyDetail) {
  const classes = useStyles();
  const { icon, title, description, height, width } = props;
  const iconHeight = height ? height : width ? "auto" : 28;
  const iconWidth = width ? width : height ? "auto" : 28;
  return (
    <div className={classes.container}>
      <img src={icon} alt="" height={iconHeight} width={iconWidth} />
      {title && title !== "" && <span>{title}</span>}
      {description && description !== "" && (
        <span className="description">{description}</span>
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: 20,
    "& > img": {
      marginBottom: 10,
    },
    "& .description": {
      fontWeight: 600,
    },
  },
});
